import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-video", () => {
    describe("General", () => {
        it("should render the video component", async () => {
            const page = await newE2EPage();
            await page.setContent(`<ux-video></ux-video>`);
            const el = await page.find("ux-video");
            expect(el).toHaveClass("hydrated");
        });

        it("should render valid html", async () => {
            await testValidHtml(`<ux-video>
                <video controls>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>`);
        });
    });

    describe("Snapshots", () => {
        it("should match to snapshot with with custom play button enabled", async () => {
            const page = await newE2EPage();
            await page.setContent(`
            <ux-video>
                <video controls>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>
        `);
            await page.waitForChanges();
            const el = await page.find("ux-video");
            expect(el).toMatchSnapshot();
        });

        it("should match to snapshot with with custom play button disabled", async () => {
            const page = await newE2EPage();
            await page.setContent(`
            <ux-video no-custom-play-button>
                <video>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>
        `);
            await page.waitForChanges();
            const el = await page.find("ux-video");
            expect(el).toMatchSnapshot();
        });
    });

    describe("Video controls & playback", () => {
        it("should apply controls if missing in video", async () => {
            const page = await newE2EPage();
            await page.setContent(`
            <ux-video>
                <video>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>
        `);
            await page.waitForChanges();
            const video = await page.find("video");
            const playButton = await page.find("ux-video >>> .ux-video__play-button");
            await playButton.click();
            await page.waitForChanges();
            expect(video).toHaveAttribute("controls");
        });

        it("should pause|play video after click on custom play button", async () => {
            const page = await newE2EPage();
            await page.setContent(`
            <ux-video>
                <video>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>
            `);
            await page.waitForChanges();
            const video = await page.find("video");
            const playButton = await page.find("ux-video >>> .ux-video__play-button");
            await playButton.click();
            let status = await video.getProperty("paused");
            expect(status).toBeFalsy();
            await playButton.click();
            status = await video.getProperty("paused");
            expect(video.getProperty(status)).toBeTruthy();
        });
    });
});
